export const client_id ='ca_HWI8nNNSCnwixgAfqoUChcwzkkdmlxOC'; 
export const redirect_uri ='http://happyleases.com/myleases';
export const stripe_pk = 'pk_test_51GwvLRG5kChqYMO55PGVgCENZgGFgyposGmi10jilCgjCdxdVYKd20jkf8c5mJgb9N5ooU4lsWibxNLOeYe8w6mD00vkITJ13W';
export const bucketName = 'happyleases-images';
export const region = 'us-west-2';
export const accessKeyId = 'AKIAIX6C7GAPDJP3WN2Q';
export const secretAccessKey = '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';

